// import $ from 'jquery'
//
// $(document).ready(function() {
//   dhsv_vc_presse_grid()
// })
//
// function dhsv_vc_presse_grid() {
//   $('.dhsv_vc_presse_grid').each(function() {})
// }
